<template>
  <div class="main" style="width: 1180px;">
    <a-card>
      <div class="topInfo">
        <div class="buildTit">{{this.$route.query.buildName}}</div>
        <div class="buildTit ml5 mr5">-</div>
        <div class="buildTit">{{this.$route.query.floorName}}</div>
        <a-button type="primary" class="ml20" @click="click_creBuildBt(1)">创建新房间</a-button>
        <!-- <a-button type="" class="ml20" style="margin-left:auto;" @click="back()">返回</a-button> -->
      </div>

      <div class="buildListWrap" v-if="getFloorData && getFloorData.floorV3RoomVoList.length > 0">
        <div class="buildList" :key="index" v-for="(item,index) in getFloorData.floorV3RoomVoList">
          <div class="topCont" :style="{height:topContHeight}">
            <div class="name">{{item.name}}</div>
            <div class="iconAll">
              <a-icon type="form" class="tableIcon mr10"  @click.stop="click_creBuildBt(0,item)"/>
              <img class="cursorPointer" src="../../assets/icon_trashCan_nor.png" alt="" @click.stop="cli_del_icon(item)">
            </div>
          </div>
          <div class="cenCont" :style="{height:cenContHeight}" v-if="item.floorV3RoomBedVoList.length > 0">
            <div class="cenList" :key="index2" v-for="(item2,index2) in item.floorV3RoomBedVoList" style="flex-direction: column;">
              <div style="width: 100%; display: flex; align-items: center;">
					<div class="bedName">{{item2.bedName}}</div>
					<div class="ml5 mr5">-</div>
					<div class="snData">{{item2.snCodeName}}</div>
					<a-icon type="form" class="tableIcon ml10"  @click="click_addEqu(0,item2)"/>
					<a-icon type="close-circle" theme="filled" class="tableIcon ml10" @click.stop="cli_del_Equ_icon(item2)"/>
			  </div>
			  <div v-if="item2.sosBindNum && item2.sosBindNum > 0" style="display: flex; flex-direction: row; margin-top: 5px; width: 100%;">
					<div class="bedName" style="color: #FFFFFF00;">{{item2.bedName}}</div>
                    <div class="ml5 mr5" style="height: 20px; color: #8C8C8C; line-height: 20px;">-</div>
                	<div style="height: 20px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8C8C8C; line-height: 20px; margin-left: -1px;">{{ '已绑定' + item2.sosBindNum + '个按钮'}}</div>
			  </div>
            </div>
          </div>
          <div class="cenCont cenContNoData" :style="{height:cenContHeight}" v-if="item.floorV3RoomBedVoList.length == 0">
            暂无设备
          </div>
          <div class="botCont" v-if="item.floorV3RoomBedVoList.length > 4">
            <div class="tips">每个房间最多支持5个监测位</div>
          </div>
          <div class="botCont bgE6F7FF cursorPointer" v-if="item.floorV3RoomBedVoList.length < 5" @click="click_addEqu(1,item)">
            <a-icon type="plus-circle" theme="filled"  class="color1890ff f20"/>
            <div class="color1890ff ml10" >添加设备</div>
          </div>
        </div>
      </div>
      
      <!-- 无数据 -->
      <div class="comNoData" v-if="getFloorData && getFloorData.floorV3RoomVoList.length == 0">
        <img src="../../assets/iconRoom.png" alt="">
        <div class="ml10">暂未创建房间，可以先尝试创建您的第一个房间</div>
      </div>


      <!-- 创建房弹窗 -->
      <a-modal :title="creBuildTan_type == 1 ? '创建新房间' : '修改房间名'" :width="400" v-model="creBuildTan" footer="">
        <div class="radarTanWrap">
          <div class="pb10">最多支持20位字符，不支持特殊符号</div>
          <input :class="['inputList',item.inputListBorRed ? 'inputListBorRed' : '']" type="text" maxlength="20" placeholder="请输入房间名" :key="index" v-for="(item,index) in buildList" v-model="item.buildName" @keyup="inputChangeHandle1(item)">
          <div class="addJcy" @click="creBuild()" v-if="creBuildTan_type == 1">
            <img class="jiaImg" src="../../assets/jia.png" alt="">
            <div>一个房间</div>
          </div>
        </div>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="creBuildTan = false">取消</el-button>
          <el-button type="primary" @click="sureCreBuild" v-if="creBuildTan_type == 1">创建</el-button>
          <el-button type="primary" @click="sureCreBuild" v-if="creBuildTan_type == 0">修改</el-button>
        </div>
      </a-modal>

      <!-- 创建房到数量限制弹窗 -->
      <a-modal title="" :width="400" v-model="buildMoreCountTan" footer="">
        <p class="delTips pt50">
          <a-icon type="exclamation-circle" />
          每层楼最多支持50个房间，需要先删除房间才能创建新房间
        </p>
        <div style="margin-top:20px;text-align: right;">
          <el-button type="primary" @click="buildMoreCountTan = false">知道了</el-button>
        </div>
      </a-modal>

      <!-- 删除房弹窗 -->
      <a-modal title="" :width="400" v-model="delBuildTan" footer="">
        <p class="delTips pt50" v-if="!item.hasRelation && (!item.sosBindNum || item.sosBindNum == 0)">
          <a-icon type="exclamation-circle" />
          即将删除房间，您确定要删除吗？
        </p>
        <p class="delTips pt50" v-if="item.hasRelation || (!item.hasRelation && item.sosBindNum > 0)">
          <a-icon type="exclamation-circle" />
          即将删除房间，已经建立的位置和设备关系也将解除，您确定要删除吗？
        </p>
        <p class="delTips colorff4d4f" v-if="item.hasConsumer">注意：本次删除包含C端用户的设备，这个操作只会删除在当前机构的位置绑定关系</p>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="delBuildTan = false">取消</el-button>
          <el-button type="primary" @click="tan_cli_del_icon()">删除</el-button>
        </div>
      </a-modal>



      <!-- 设备部分 -->
      <!-- 添加设备弹窗 -->
      <a-modal :title="addEquTan_type == 1 ? '添加设备' : '修改设备'" :width="400" v-model="addEquTan" footer="">
        <div class="radarTanWrap">
          <div class="pb10">最多支持20位字符，不支持特殊符号</div>
          <div class="roomList" :key="index" v-for="(item,index) in bedList">
            <input :class="['comInput inputL',item.inputListBorRed ? 'inputListBorRed' : '']" type="text" maxlength="20" placeholder="请输入位置信息" v-model="item.bedName" @keyup="inputChangeHandle(item)">
            <!-- <div class="pr" :style="{border: redTip_msg ? 'border: 1px solid red' : ''}"> -->
            <div class="pr">
              <input :style="{border: redTip_msg ? '1px solid #ff4d4f' : ''}" class="comInput inputR" type="text" placeholder="请输入设备SN" @focus="focusInputR" @blur="blurInputR" v-model="item.snCode"  onkeyup = "value=value.replace(/[\u4E00-\u9FA5]/g,'')" @input="changeInputSn(index)">
              <div class="searData" style="height:300px;overflow:auto;" v-if="searDataShow && index == searDataShowIndex">
                <div :class="['searList',searchItem.disabled ? 'colorBFBFBF' : 'cursorPointer']" :key="searchIndex" v-for="(searchItem,searchIndex) in searData" @click="clickSearSel(index,searchItem)">{{searchItem.name}}</div>
              </div>
            </div>
          </div>
          <div class="colorff4d4f" v-if="redTip_msg">{{redTip_msg}}</div>
          <div class="addJcy" @click="creEqu()" v-if="addEquTan_type == 1">
            <img class="jiaImg" src="../../assets/jia.png" alt="">
            <div>设备</div>
          </div>
        </div>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="addEquTan = false">取消</el-button>
          <el-button type="primary" @click="sureCreEqu" v-if="addEquTan_type == 1">添加</el-button>
          <el-button type="primary" @click="sureCreEqu2" v-if="addEquTan_type == 0">修改</el-button>
        </div>
      </a-modal>
      <!-- 添加监测仪后反馈弹窗web3.0 -->
      <a-modal v-model="addEquFeedback" footer="" :width="400" title="">
        <div class="pt50" style="display:flex;" v-if="v3_radarBedData">
          <img class="imgIconTK mr10" src="../../assets/iconOrangeAlarm.png" alt="">
          <div>
            <div>
              添加成功
              <span style="color:#63B5FF;">{{v3_radarBedData.succNum}}</span>
              台,添加失败
              <span style="color:#FF9C9D;">{{v3_radarBedData.failNum}}</span>
              台,失败原因如下：
            </div>
            <div v-if="v3_radarBedData.noExist.num != 0">
              有以下
              <span style="color:#63B5FF;">{{v3_radarBedData.noExist.num}}</span>
              个SN码不存在：
              <div style="display:flex;flex-wrap: wrap;">
                <div :key="index" v-for="(item,index) in v3_radarBedData.noExist.radarList">
                  <div v-if="v3_radarBedData.noExist.radarList.length == 1">{{item}}</div>
                  <div v-if="v3_radarBedData.noExist.radarList.length > 1 && index != v3_radarBedData.noExist.radarList.length-1">{{item}}、</div>
                  <div v-if="v3_radarBedData.noExist.radarList.length > 1 && index == v3_radarBedData.noExist.radarList.length-1">{{item}}</div>
                </div>
              </div>
            </div>
            <div v-if="v3_radarBedData.bindList.failNum != 0">
              <div :key="index" v-for="(item,index) in v3_radarBedData.bindList">
                有以下<span style="color:#63B5FF;">{{item.num}}</span>个SN码已绑定在{{item.tenant}}
                <span v-if="item.tenant == 'C端用户'">，</span>
                <span v-if="item.tenant == 'C端用户'" style="color: #FF8081;">继续添加会把关系拉到当前机构</span>
                ：
                <div style="display:flex;flex-wrap: wrap;">
                  <div :key="index2" v-for="(item2,index2) in item.radarList">
                    <div v-if="item.radarList.length == 1">{{item2}}</div>
                    <div v-if="item.radarList.length > 1 && index2 != item.radarList.length-1">{{item2}}、</div>
                    <div v-if="item.radarList.length > 1 && index2 == item.radarList.length-1">{{item2}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top:20px;text-align: right;">
          <!-- 失败里面没有c端机构 -->
          <el-button type="primary" @click="addEquFeedback = false" v-if="!v3_radarBedData.fail_haveC">知道了</el-button>

          <!-- 失败里面有c端机构 -->
          <el-button type="primary" @click="addEquFeedback = false" v-if="v3_radarBedData.fail_haveC">关闭</el-button>
          <el-button type="primary" @click="add_c_UserArr()" v-if="v3_radarBedData.fail_haveC">继续添加</el-button>
          <!-- <el-button type="primary" @click="cli_goAddRadar()" v-if="">继续添加</el-button> -->
        </div>
      </a-modal>

      <!-- 删除设备弹窗 -->
      <a-modal title="" :width="400" v-model="delEquTan" footer="">
        <p class="delTips pt50" v-if="!item.hasRelation && (!item.sosBindNum || item.sosBindNum == 0)">
          <a-icon type="exclamation-circle" />
          即将删除位置，您确定要删除吗？
        </p>
        <p class="delTips pt50" v-if="item.hasRelation || (!item.hasRelation && item.sosBindNum > 0)">
          <a-icon type="exclamation-circle" />
          即将删除位置，已经建立的位置和设备关系也将解除，您确定要删除吗？
        </p>
        <p class="delTips colorff4d4f" v-if="item.hasConsumer">注意：本次删除包含C端用户的设备，这个操作只会删除在当前机构的位置绑定关系</p>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="delEquTan = false">取消</el-button>
          <el-button type="primary" @click="tan_cli_del_Equ_icon()">删除</el-button>
        </div>
      </a-modal>
      <!-- 修改设备弹窗 -->
      <a-modal title="" :width="400" v-model="modifyEquTan" footer="" :maskClosable="false">
        <!-- 关联的设备带录入信息 -->
        <div v-if="modifyState">
          <p class="delTips pt50" v-if="modifyState.clearBedInfo">
            <a-icon type="exclamation-circle" />
            您正在更换位置，是否要清空设备已录入的信息
          </p>
          <p class="delTips pt50" v-if="modifyState.inheritBedInfo">
            <a-icon type="exclamation-circle" />
            您正在更换位置，原设备已录入的信息是否要继承在新设备上?
          </p>
          <p class="delTips pt50" v-if="modifyState.unbindRadarBed">
            <a-icon type="exclamation-circle" />
            确定解绑与当前位置关联的设备吗?
          </p>
          <div style="margin-top:20px;text-align: right;">
            <el-button v-if="modifyState.unbindRadarBed" @click="unbindRadarBedCancel">取消</el-button>
            <el-button v-if="!modifyState.unbindRadarBed" @click="modifyEquTan = false">取消</el-button>
            <el-button type="primary" @click="tan_cli_modify_Equ_oper('clearBedInfo',1)" v-if="modifyState.clearBedInfo">清空</el-button>
            <el-button type="primary" @click="tan_cli_modify_Equ_oper('inheritBedInfo',1)" v-if="modifyState.inheritBedInfo">不继承</el-button>
            <el-button type="primary" @click="tan_cli_modify_Equ_oper('inheritBedInfo',2)" v-if="modifyState.inheritBedInfo">继承</el-button>
            <el-button type="primary" @click="tan_cli_modify_Equ_oper('unbindRadarBed',1)" v-if="modifyState.unbindRadarBed">解绑</el-button>
          </div>
        </div>
      </a-modal>


    </a-card>
  </div>
</template>

<script>
const synth = window.speechSynthesis
const msg = new SpeechSynthesisUtterance()
export default {
  components: {
    
  },
  data() {
    return {
      buildId: this.$route.query.buildId,
      floorId: this.$route.query.floorId,
      getFloorData: '',               //获取层对象数据
      creBuildTan: false,             //创建层弹窗
      buildList: [{buildName: ''}],
      buildMoreCountTan: false,       //创建层到数量限制弹窗
      delBuildTan: false,             //删除层弹窗
      item: '',                       //当前操作的操作的item
      creBuildTan_type: '',           //1创建层 0修改层
      topContHeight: '',              //topCont类名高度设置
      cenContHeight: '',              //cenCont类名高度设置


      addEquTan: false,               //添加设备弹窗
      v3_radarBedData: '',            //添加设备接口数据
      addEquFeedback: false,          //添加设备成功失败反馈弹窗
      bedList: [{bedName: '1',snCode: ''}],
      c_userArr: [],                  //继续添加C端用户的列表
      equMoreCountTan: false,         //创建层到数量限制弹窗
      delEquTan: false,               //删除层弹窗
      addEquTan_type: '',             //1添加设备 0修改设备
      oldsnCode: '',                  //修改设备的老snCode
      searDataShow: false,            //搜索信息是否显示
      searDataShowIndex: -1,          //搜索信息是否显示第几条
      searData: false,                //搜索信息数据
      searTimer: null,                //搜索防抖

      modifyEquTan: false,            //修改设备弹窗 二次弹窗
      redTip_msg: '',                 //修改时检验设备不存在 || 绑定在其他机构 等等
      // 修改设备状态
      modifyState: {
        clearBedInfo: 0,                //清空设备已录入信息状态: 0-初始 1-清空	
        inheritBedInfo: 0,              //继承原设备已录入信息状态: 0-初始 1-不继承 2-继承
        unbindRadarBed: 0,              //解绑位置关联设备状态: 0-初始 1-解绑	
      },



    };
  },
  created() {
    
  },
  mounted() {
    this.getFloor()     //获取层对象
  },
  methods: {
	inputChangeHandle(e){
		e.bedName = e.bedName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g,'')
	},
	inputChangeHandle1(e){
		e.buildName = e.buildName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g,'')
	},
    // 获取层对象
    getFloor(){
      let param = {
        id: this.floorId,
      }
      this.$get(
        "/api/v3/floor/getFloor",
        param,
        (res) => {
          if (res.code == 0) {
            this.getFloorData = res.data
            this.topContHeight = 'auto';       //要赋值的变量 初始高度设置auto
            this.cenContHeight = 'auto';       //要赋值的变量 初始高度设置auto
            setTimeout(() => {
              this.init_buildNameHeiTop('.topCont','topContHeight')
              this.init_buildNameHeiTop('.cenCont','cenContHeight')
            }, 0);
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error(err.msg);
        }
      );
    },
    // 初始化buildName高度动态配置(类名,要赋值的变量)
    init_buildNameHeiTop(className,setVariable){
      let elem = document.querySelectorAll(className);
      let heiTop = 0;
      for(let i = 0;i < elem.length;i++){
        let nowTop = elem[i].getBoundingClientRect().height
        if(nowTop > heiTop){
          heiTop = nowTop
        }
      }
      this[setVariable] = heiTop + 'px'
      // console.log(this.topContHeight,this[setVariable])
      // console.log(this.cenContHeight,this[setVariable])
    },
    // 点击创建新楼按钮(type 1创建 0修改)
    click_creBuildBt(type,item){
      this.creBuildTan_type = type; //1创建楼 0修改楼
      console.log(type)
      if(type == 1){
        if(this.getFloorData.floorV3RoomVoList.length < 50){
          this.buildList = [{buildName: ''}];
          this.creBuildTan = true;
        }else{
          this.buildMoreCountTan = true;
        }
      }else if(type == 0){
        this.item = item;     //当前操作的操作的item
        this.buildList = [{buildName: this.item.name}];
        this.creBuildTan = true;
      }
    },
    // +一个房间
    creBuild(){
      let nowLength = this.buildList.length + this.getFloorData.floorV3RoomVoList.length    //当前一共多少层
      if(nowLength < 50){
        let buildName = { buildName: "" };
        this.buildList.push(buildName);
      }else{
        this.$message.error("每层最多支持50个房间，需要先删除房间才能创建新房间");
      }
    },
    // 创建新楼弹框内点击确定走创建新楼接口
    sureCreBuild(){
      let isCanGo = 0;    //是否能添加 只要循环里有一个有数据即可添加
      for(let i = 0;i < this.buildList.length;i++){
        if(this.buildList[i].buildName){
          isCanGo = 1
          this.buildList[i].inputListBorRed = false;
        }else{
          this.buildList[i].inputListBorRed = true;
        }
      }
      // this.loading = true;
      if(isCanGo != 1){
        this.$forceUpdate()
        return;
      }
      if(this.creBuildTan_type == 1){             //创建楼
        let roomNameList = []
        for(let i = 0;i < this.buildList.length;i++){
          if(this.buildList[i].buildName){
            roomNameList.push(this.buildList[i].buildName)
          }
        }
        let param = {
          buildingId: this.buildId,
          floorId: this.floorId,
          roomNameList: roomNameList,
        };
        this.$post(
          "/api/v3/room",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.creBuildTan = false;
              this.getFloor()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }else if(this.creBuildTan_type == 0){       //修改楼
        let param = {
          // buildingId: this.buildId,
          // floorId: this.floorId,
          id: this.item.id,
          name: this.buildList[0].buildName,
        }
        this.$put(
          "/api/v3/room",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.creBuildTan = false;
              this.getFloor()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }
    },
    // 点击删除icon
    cli_del_icon(item){
      this.item = item;          //当前操作的操作的item
      this.delBuildTan = true;   //弹窗显示
    },
    // 弹窗内点击删除
    tan_cli_del_icon(){
      let param = {
        hasRelation: this.item.hasRelation,
        id: this.item.id,
      }
      this.$delete(
        "/api/v3/room/delete",
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.delBuildTan = false;
            this.getFloor()
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error(err.msg);
        }
      );
    },






    // 点击添加设备(type 1创建 0修改)
    click_addEqu(type,item){
      this.addEquTan_type = type; //1添加设备 0修改设备
      this.item = item;
      this.addEquTan = true;
      console.log(type,item)
      if(type == 1){
        this.bedList = [{bedName: '',snCode: ''}];
      }else if(type == 0){
        this.bedList = [{bedName: item.bedName,snCode: item.snCode}];
        this.oldsnCode =  item.snCode
        this.init_modifyState();      //修改设备状态初始化
      }
    },
    // 获取焦点
    focusInputR(){
      // this.searDataShow = true;
    },
    // 失去焦点
    blurInputR(){
      setTimeout(() => {
        this.searDataShow = false;
      }, 100);
      
    },
    // inputSn框输入搜索
    changeInputSn(index){
      this.searDataShowIndex = index;   //搜索信息是否显示第几条
      console.log(index)
      clearTimeout(this.searTimer);
      if(this.bedList[index].snCode){
        this.searDataShow = false;
      }
      this.searTimer = setTimeout(() => {
        console.log(this.bedList[index].snCode)
        let param = {
          snKeyword: this.bedList[index].snCode
        }
        this.$get(
          "/api/v3/radarBed/getSnCodeList",
          param,
          (res) => {
            if (res.code == 0) {
              this.searData = res.data;
              console.log(this.bedList)
              if(this.addEquTan_type == 1){         //添加
                for(let i = 0;i < this.searData.length;i++){
                  for(let j = 0;j < this.bedList.length;j++){
                    if(this.searData[i].value == this.bedList[j].snCode){
                      this.searData[i].disabled = true;
                    }
                  }
                }
              }else if(this.addEquTan_type == 0){   //修改
                for(let i = 0;i < this.searData.length;i++){
                  this.searData[i].value
                  if(this.searData[i].value == this.oldsnCode){
                    this.searData[i].name = this.searData[i].name.split('-')[0]
                    this.searData[i].disabled = false;
                  }
                }
              }
              console.log(this.searData)
              if(this.searData.length != 0){
                this.searDataShow = true;
              }else{
                this.searDataShow = false;
              }
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }, 1000);
    },
    // 搜索中选中某一个
    clickSearSel(index,searchItem){
      console.log(index,searchItem)
      if(!searchItem.disabled){
        this.bedList[index].snCode = searchItem.value;
      }
    },
    // +设备
    creEqu(){
      let nowLength = this.bedList.length + this.item.floorV3RoomBedVoList.length
      if(nowLength < 5){
        let bedName = { bedName: "" };
        this.bedList.push(bedName);
      }else{
        this.$message.error("每个房间最多支持5个设备，需要先删除设备才能创建新设备");
      }
    },

    // 创建新设备弹框内点击确定
    sureCreEqu(){
      let isCanGo = 0;    //是否能添加 只要循环里有一个有数据即可添加
      console.log(this.bedList)
      for(let i = 0;i < this.bedList.length;i++){
        if(this.bedList[i].bedName){
          isCanGo = 1
          this.bedList[i].inputListBorRed = false;
        }else{
          this.bedList[i].inputListBorRed = true;
        }
      }
      // this.loading = true;
      if(isCanGo != 1){
        this.$forceUpdate()
        return;
      }
      if(this.addEquTan_type == 1){             //添加设备
        let radarBedList = this.deleteJsonKey(this.bedList,['inputListBorRed'])   //删除数组key
        console.log(radarBedList)
		// 之前的逻辑
        // 去除数组中的空数据 
        // let radarBedList2 = []
        // for(let i = 0;i < radarBedList.length;i++){
        //   if(radarBedList[i].bedName != '' && radarBedList[i].snCode){
        //     radarBedList2.push(radarBedList[i])
        //   }
        // }
		// 2023.12.20修改
        // 去除数组中的空数据 
        let radarBedList2 = []
        for(let i = 0;i < radarBedList.length;i++){
          if(radarBedList[i].bedName != ''){
            radarBedList2.push(radarBedList[i])
          }
        }
        let param = {
          buildingId: this.buildId,
          floorId: this.floorId,
          roomId: this.item.id,
          radarBedList: radarBedList2,
        };

        this.$post(
          "/api/v3/radarBed",
          param,
          (res) => {
            if (res.code == 0) {
              
              this.addEquTan = false;
              if(res.data == null){
                console.log('进入了添加成功')
                this.$message.success("添加成功")
              }else{
                this.v3_radarBedData = res.data;     //添加设备接口数据
                this.addEquFeedback = true;       //添加设备成功失败反馈弹窗

                this.v3_radarBedData.fail_haveC = false;      //失败里面是否有c端机构设备
                for(let i = 0;i < this.v3_radarBedData.bindList.length;i++){
                  console.log(1321)
                  if(this.v3_radarBedData.bindList[i].tenant == 'C端用户'){
                    console.log('失败里面有c端机构')
                    this.v3_radarBedData.fail_haveC = true;   //失败里面有c端机构
                  }
                }
              }
              this.getFloor()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );





        // setTimeout(() => {
        //   this.$post(
        //     "/api/v3/radarBed/addConsumer",
        //     param,
        //     (res) => {
        //       if (res.code == 0) {
        //         this.getFloor()
                
        //       } else {
        //         // this.$message.error(res.msg);
        //       }
        //     },
        //     (err) => {
        //       // console.log(err);
        //       // this.$message.error(err.msg);
        //     }
        //   );
        // }, 0);
      }else if(this.addEquTan_type == 0){       //修改设备
        let param = {
          bedId: this.item.bedId,                       //位置信息ID	
          bedName: this.bedList[0].bedName,                   //位置信息	
          radarId: this.item.radarId,                   //设备ID	
          snCode: this.bedList[0].snCode,                     //设备SN	
          clearBedInfo: this.modifyState.clearBedInfo,              //清空设备已录入信息状态: 0-初始 1-清空	
          inheritBedInfo: this.modifyState.inheritBedInfo,          //继承原设备已录入信息状态: 0-初始 1-不继承 2-继承	
          unbindRadarBed: this.modifyState.unbindRadarBed,          //解绑位置关联设备状态: 0-初始 1-解绑	
        }
        this.$put(
          "/api/v3/radarBed",
          param,
          (res) => {
            if (res.code == 0) {
              if(res.data == null){
                this.addEquTan = false;
                this.modifyEquTan = false;
                this.$message.success(res.msg);
                this.getFloor();
              }else{
                this.redTip_msg = '';
                this.modifyState = res.data;
                this.modifyEquTan = true;
              }
            } else {
              this.redTip_msg = res.msg;        //修改时检验设备不存在 || 绑定在其他机构 等等
              // this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }
    },
    add_c_UserArr(){
      let radarBedList = this.deleteJsonKey(this.bedList,['inputListBorRed'])   //删除数组key
      console.log(radarBedList)
      let param = {
        buildingId: this.buildId,
        floorId: this.floorId,
        roomId: this.item.id,
        radarBedList: radarBedList,
      };


      let param2 = {
        buildingId: this.buildId,
        floorId: this.floorId,
        roomId: this.item.id,
        radarBedList: [
          {
            bedName: '32423',
            snCode: 'C4DEE20CD28C'
          }
        ],
      }
      this.$post(
        "/api/v3/radarBed/addConsumer",
        param,
        (res) => {
          if (res.code == 0) {
            this.getFloor()
            
          } else {
            // this.$message.error(res.msg);
          }
        },
        (err) => {
          // console.log(err);
          // this.$message.error(err.msg);
        }
      );
      this.addEquFeedback = false
    },
    sureCreEqu2(){
      this.modifyState.clearBedInfo = 0;
      this.modifyState.inheritBedInfo = 0;
      this.modifyState.unbindRadarBed = 0;
      this.sureCreEqu();
    },
    // 修改设备状态初始化
    init_modifyState(){
      this.modifyState.clearBedInfo = 0;
      this.modifyState.inheritBedInfo = 0;
      this.modifyState.unbindRadarBed = 0;
    },
    // 修改二次弹窗操作
    tan_cli_modify_Equ_oper(typeName,type){
      this.modifyState[typeName] = type;
      this.sureCreEqu();
    },
    // 修改二次弹窗中 解绑弹窗 点击取消
    unbindRadarBedCancel(){
      this.bedList[0].snCode = this.oldsnCode;
      this.modifyEquTan = false;
    },
    // 点击删除icon
    cli_del_Equ_icon(item){
      this.item = item;          //当前操作的操作的item
      this.delEquTan = true;   //弹窗显示
    },
    // 弹窗内点击删除
    tan_cli_del_Equ_icon(){
      let param = {
        bedId: this.item.bedId,
        hasBedInfo: this.item.hasBedInfo,
        hasRelation: this.item.hasRelation,
        radarId: this.item.radarId,
        snCode: this.item.snCode,
        type: this.item.type,
      }
      this.$delete(
        "/api/v3/radarBed/delete",
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.delEquTan = false;
            this.getFloor()
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error(err.msg);
        }
      );
    },




    // 删除数组key
    deleteJsonKey(target, keys) {
      if (target.length == 0) {
        return target
      }
      let result = []
      if (Array.isArray(keys)) {
        let mixed = Object.keys(...target).filter(x => !new Set(keys).has(x))
        result = JSON.parse(JSON.stringify(target, mixed))
      } else {
        result = JSON.parse(JSON.stringify(target, (k, v) => {
          if (k !== keys) {
            return v
          }
        }))
      }
      return result
    }

  },
};
</script>
<style lang="scss" scoped>
.main::v-deep {
  padding: 20px 0;
  .ant-card {
    padding: 20px 20px 30px 20px;
    border-radius: 8px;
    .ant-card-body {
      padding: 0;
    }
  }
  .ant-tabs-bar {
    border-bottom: none;
  }
  .topInfo{
    display: flex;
    .buildTit{
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
    }
  }
  .buildListWrap{
    display:flex;
    flex-wrap: wrap;
    .buildList:nth-of-type(3n+1){
      margin-left: 0;
    }
    .buildList{
      width: 371px;
      height: 275px;
      height: auto;
      color: #262626;
      background: #FFFFFF;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 20px;
      margin-left: 12px;
      position: relative;
      .topCont{
        padding-top: 20px;
        display: flex;
        .name{
          width: 270px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #262626;
          display: flex;
          // justify-content: center;
          align-items: center;
        }
        .iconAll{
          margin-left: auto;
          display: flex;
          align-items: center;
          .tableIcon {
            color: #1890ff;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
      .cenCont{
        min-height: 293px;
        padding-bottom: 55px;
        display: flex;
        flex-direction:column;
        justify-content: center;
        .cenList{
          display: flex;
          margin-top: 10px;
          align-items: center;
          .bedName{
            width: 70px;
            word-break:break-all;
            text-align: right;
          }
          .tableIcon {
            color: #1890ff;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
      .cenContNoData{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .botCont{
        width: 100%;
        height: 45px;
        background: #F0F0F0;
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.imgIconTK {
  width: 18px;
  height: 18px;
}
</style>